module.exports = __webpack_public_path__ + "static/media/star-unfilled.07fae28f.svg";